import { createStore } from 'vuex'
import product from './product'
import cart from './cart'
import checkout from './checkout'
// import query from './query'

export default createStore({
    state: {
        settings: {
            pageName: null,
        },
        error: null
    },
    actions: {
        initSettings({ commit }) {
            commit('setSettings')
        }
    },
    mutations: {
        setSettings(state) {
            let page
            let metaVuex = document.querySelector('meta[name="vuex"]')
            if (metaVuex) page = metaVuex.getAttribute('page')
            state.settings.pageName = page
        },
        setError(state, error) {
            state.error = error
        },
        clearError(state) {
            state.error = null
        }
    },
    getters: {
        getSettings: s => s.settings,
        error: s => s.error
    },
    modules: {
        product, cart, checkout
    }
})
